module.exports = __webpack_public_path__ + "img/wallet.99a22bd0.svg";